import {
  BaseCard,
  Heading,
  Primary,
  SvgIcon,
  Text,
  TextLink,
} from '@cinch-labs/design-system'
import styles from './site-card.module.css'
import cn from 'classnames'
import { FindASiteProps, ListedSite } from '../../find-a-site'
import { formatSiteAddress } from '@cinch-nx/shared-sites'

interface SiteCardProps {
  site: ListedSite
  onClick: FindASiteProps['onSiteCardClick']
  postcode: string
  isSelected: boolean
  buttonText: string
  showCinchStoresFreeOnCard: boolean
}

export const SiteCard = ({
  site,
  onClick,
  postcode,
  isSelected,
  buttonText,
  showCinchStoresFreeOnCard,
}: SiteCardProps) => (
  <BaseCard
    hasBorder
    className={cn(styles.card, { [styles.selected]: isSelected })}
  >
    <Heading element="h3" color="meteorite" className={styles.heading}>
      {site.siteName}
    </Heading>
    {showCinchStoresFreeOnCard && site.site.hasTagAttribute('cinch-store') && (
      <Text
        color="mineShaft"
        fontSize="m"
        fontWeight="bold"
        className={styles.freeCollection}
      >
        Free collection
      </Text>
    )}
    <Text color="mineShaft" fontSize="s" className={styles.address}>
      {formatSiteAddress(site.address)}
    </Text>
    <Text color="dove" fontSize="s" className={styles.distance}>
      {site.distance} miles away
    </Text>
    <div className={styles.mapLink}>
      <TextLink
        href={`https://www.google.com/maps/dir/?api=1&origin=${postcode}&destination=${site.coordinates.latitude},${site.coordinates.longitude}`}
        element="a"
        target="_blank"
      >
        <Text fontSizeFixed="s">
          <SvgIcon name="new-tab" /> Map and directions
        </Text>
      </TextLink>
    </div>
    <Primary onClick={() => onClick(site.site)}>{buttonText}</Primary>
  </BaseCard>
)
